import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Box, IconButton } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Catalogs } from '@europrocurement/l2d-domain';
import ActionMenuItems from './Menu/ActionMenuItems';

const ActionMenuGrilleTarifaire: React.FunctionComponent<{
    showPrescripteur: boolean;
    showCatalogue: boolean;
    showPackage: boolean;
    catalogue: Catalogs;
}> = function ({
    showPrescripteur = false,
    showCatalogue = false,
    showPackage = false,
    catalogue = null,
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const menuRef = useRef<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // Fonction pour gérer les clics en dehors du menu
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Box
            ref={menuRef}
            onClick={(e) => {
                e.stopPropagation();
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
        >
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FaOptionIcon
                    icon={['fasl', 'ellipsis-vertical']}
                    sx={{ fontSize: '1rem' }}
                />
            </IconButton>
            <ActionMenuItems
                showPrescripteur={showPrescripteur}
                showCatalogue={showCatalogue}
                showPackage={showPackage}
                catalogue={catalogue}
                close={handleClose}
                open={open}
                anchorEl={anchorEl}
            />
        </Box>
    );
};

export default ActionMenuGrilleTarifaire;
